import React from 'react';
import { Paper, TypographyBody } from '@honeycomb/ui-core';
export function CollapsedSearchLabel({ children, height, isPlaceholder = false, }) {
    return (React.createElement(Paper, { radius: "s", px: 3, border: 0, h: height, bg: "background.offset", display: "flex", w: "100%", alignItems: "center" },
        React.createElement(TypographyBody, { size: "s", truncate: true, weight: isPlaceholder ? 'regular' : 'bold', color: "common.black" }, children)));
}
